import { NNotification } from "./NNotification";
import { User } from "./User";
import { UserType } from './UserTypes';


export class Doctor implements User {
	id = '';
	email = '';
	typeUser = UserType.Doctor;
	notifications : NNotification[];

	constructor(id : string, email : string) {
		this.id = id
		this.email = email
		this.notifications = []
	}


}
